import { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { immediateToast } from 'utils/toast';
import AnimatedLayout from 'components/layouts/animated-layout';
import { useWalletsQuery } from 'app/store';
import { TransactionsDataTable, WalletCard } from 'features/profile';
import { Wallet } from 'features/profile/types/wallet.types';
import { SettingsContentHeader } from 'components/layouts/settings-workspace/settings-workspace';
import HelmetTabComponent from 'components/helmet-tab/helmet-tab';

const walletsTitle: Record<string, string> = {
    sms: 'کیف پول پیامک',
    wage: 'کیف پول کارمزد',
};

const walletKeys = ['sms', 'wage'];

const WalletsTab = () => {
    const [transactionsWallet, setTransactionsWallet] = useState<Wallet | null>(
        null,
    );

    const { data: wallets, isLoading: isLoadingWallets } = useWalletsQuery({});
    const [searchParams] = useSearchParams();
    const walletName = searchParams.get('walletName');

    useEffect(() => {
        if (searchParams.get('status') === 'success') {
            immediateToast('success', {
                message: 'کیف پول شما با موفقیت شارژ شد',
            });
        }
    }, [searchParams]);

    return (
        <AnimatedLayout>
            <HelmetTabComponent title="کیف پول" />

            <SettingsContentHeader
                title="کیف پول"
                description="موجودی و گردش حساب کیف پول پیامک و کارمزد را مدیریت کنید."
            />

            <Grid spacing={2.25} container>
                {walletKeys.map((walletKey) => {
                    const wallet = wallets?.find(
                        (item) => item.name === walletKey,
                    );

                    return (
                        <Grid xs={12} md={6} item key={walletKey}>
                            <WalletCard
                                name={walletKey}
                                onMoreData={() => {
                                    if (wallet) {
                                        setTransactionsWallet(wallet);
                                    }
                                }}
                                title={walletsTitle[walletKey]}
                                navigatedOpen={walletKey === walletName}
                                amount={wallet?.balance}
                                isLoading={isLoadingWallets}
                                id={wallet?.id}
                            />
                        </Grid>
                    );
                })}
            </Grid>

            <TransactionsDataTable
                wallet={transactionsWallet}
                onClose={() => setTransactionsWallet(null)}
                showDetails={false}
            />
        </AnimatedLayout>
    );
};

export default WalletsTab;
